<div #sidebarContentElement class="control-sidebar-content">
  <ng-content></ng-content>
</div>
<div class="control-sidebar-bg"></div>
